import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { ChipCell } from 'components/shared/Table/common/Cells/ChipCell/ChipCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { PrimaryCell } from 'components/shared/Table/common/Cells/PrimaryCell/PrimaryCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'
import { FeatureFlag } from 'components/auth/FeatureFlag'
import { getLanguageSymbol } from 'utils/languages'
import { getActions } from './helpers'
import { useMessagesTable } from './hooks'
import { getMessageTypeLabel } from './model'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { capitalizeFirstLetter } from 'utils/stringFormat'

const mapSortingPropToQueryParam = {
  creation_date: 'creation_date',
  project_name: 'project_name',
}

export const MessagesTable = ({ search, onEdit, filter }) => {
  const { state, handlers } = useMessagesTable({
    mapSortingPropToQueryParam,
    search,
    filter,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, rowActions, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row type="head">
            {R.map(({ columnDef, getToggleSortingHandler, getIsSorted }) => {
              const { accessorKey, header, alignLeft } = columnDef

              return (
                <HeaderCell
                  key={header}
                  alignLeft={!!alignLeft}
                  sortType={getIsSorted()}
                  text={header}
                  onClick={getToggleSortingHandler()}
                  hasSorting={accessorKey}
                />
              )
            }, headers)}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{ title: t`No message templates yet` }}
          isLoaded={R.not(isFetching)}
        >
          {R.map(({ id, original }) => {
            const { creation_date, language, message_type, department } =
              original

            const actions = getActions(
              { actions: rowActions, template: original },
              { onEdit },
            )
            const symbol = getLanguageSymbol(language)
            const label = getMessageTypeLabel({ message_type })

            const title = `${capitalizeFirstLetter(
              department.name,
            )} ${label.toLowerCase()} (${language})`

            return (
              <Table.Row key={id} type="body">
                <PrimaryCell primary={title} hasIncreasedHeight />
                <ChipCell color="primary" hasIncreasedHeight {...{ label }} />
                <TextCell text={symbol} hasIncreasedHeight />
                <DateCell date={creation_date} hasIncreasedHeight />
                <TextCell text={department.name} hasIncreasedHeight />
                <ActionsCell>
                  <FeatureFlag accountAdmin>
                    <ActionsDropdown size="medium" {...{ actions }} />
                  </FeatureFlag>
                </ActionsCell>
              </Table.Row>
            )
          }, model.rows)}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
